var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { bound } from '../../../../utils/decorators/basic';
import { getEventClass } from '../../../event/getEventClass';
export class AspectEventCreation {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectEvents() {
        return this.parent;
    }
    get aspect() {
        return this.aspectEvents.aspect;
    }
    createFromRawEvent(rawEvent) {
        // const eventType = rawEvent.type || (rawEvent.reactEvent && rawEvent.reactEvent.type);
        const EventClass = getEventClass(rawEvent.type);
        const event = new EventClass({
            rawEvent,
            aspect: this.aspect,
        });
        return event;
    }
    createAndFireFromRawEvent(rawEvent) {
        try {
            const event = this.createFromRawEvent(rawEvent);
            this.aspectEvents.eventReception.handleEvent(event);
            return event;
        }
        catch (e) {
            console.log(e);
        }
    }
}
__decorate([
    bound
], AspectEventCreation.prototype, "createFromRawEvent", null);
__decorate([
    action.bound
], AspectEventCreation.prototype, "createAndFireFromRawEvent", null);
